import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Loader2, ImageOff, FileText, Download } from "lucide-react";

// Fetches a private chat file as a blob (auth cookie/bearer) and renders it by type.
export const SecureMedia = ({ fileId, type, fileName, testId, dark = false }) => {
  const [url, setUrl] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let revoked = null;
    let active = true;
    if (!fileId) return;
    setUrl(null);
    setErr(false);
    api
      .get(`/files/${fileId}/download`, { responseType: "blob" })
      .then((res) => {
        if (!active) return;
        const blobUrl = URL.createObjectURL(res.data);
        revoked = blobUrl;
        setUrl(blobUrl);
      })
      .catch(() => active && setErr(true));
    return () => {
      active = false;
      if (revoked) URL.revokeObjectURL(revoked);
    };
  }, [fileId]);

  if (!fileId) return null;
  if (err)
    return (
      <div className={`grid place-items-center h-24 rounded-lg ${dark ? "bg-white/10 text-white/70" : "bg-slate-100 text-slate-400"}`}>
        <ImageOff className="h-5 w-5" />
      </div>
    );
  if (!url)
    return (
      <div className={`grid place-items-center h-24 rounded-lg ${dark ? "bg-white/10" : "bg-slate-100"}`}>
        <Loader2 className="h-5 w-5 animate-spin text-slate-400" />
      </div>
    );

  if (type === "IMAGE")
    return <img data-testid={testId} src={url} alt={fileName || "attachment"} className="rounded-lg max-h-64 w-auto max-w-full object-contain" />;
  if (type === "VIDEO")
    return <video data-testid={testId} src={url} controls playsInline className="rounded-lg max-h-64 w-auto max-w-full bg-black" />;
  return (
    <a
      data-testid={testId}
      href={url}
      download={fileName || "attachment"}
      className={`inline-flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium ${dark ? "bg-white/10 text-white" : "bg-slate-100 text-foreground"}`}
    >
      <FileText className="h-4 w-4 shrink-0" />
      <span className="truncate max-w-[180px]">{fileName || "Attachment"}</span>
      <Download className="h-3.5 w-3.5 shrink-0 opacity-70" />
    </a>
  );
};
